export default __webpack_public_path__ + "static/media/project.bb2ff351.svg";